export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:1337';

export const LANGUAGES = Object.freeze({
    SERBIAN: 'sr',
    ENGLISH: 'en'
})
